module.exports = __webpack_public_path__ + "static/tree_leafs_albedo-550d46abdacc9ded863d3b64c35f2600.png";